import { MappedContractStatusProps } from './types.ts'
import styles from './MappedContractStatus.module.scss'
import { CONTRACT_STATUSES } from '@boltenergy-be/shared'

const MappedContractStatus = ({ status }: MappedContractStatusProps) => {
  /**
   * Determines the color classname the MappedContractStatus should have
   *
   * @returns {string}
   */
  const getMappedContractStatusConfig = (): { className: string; text: string } | undefined => {
    switch (status) {
      // Inactive
      case CONTRACT_STATUSES.error:
      case CONTRACT_STATUSES.recovery:
      case CONTRACT_STATUSES.unknownPoint:
      case CONTRACT_STATUSES.waiting14Days:
        return {
          className: styles.informative,
          text: 'Inactive'
        }

      // In progress
      case CONTRACT_STATUSES.active:
      case CONTRACT_STATUSES.ilcOngoing:
      case CONTRACT_STATUSES.inactive:
      case CONTRACT_STATUSES.rejected:
      case CONTRACT_STATUSES.validationReject:
        return {
          className: styles.informative,
          text: 'In progress'
        }

      // Wrong energy product
      case CONTRACT_STATUSES.wrongEnergyProduct:
        return {
          className: styles.negative,
          text: 'Wrong energy product'
        }

      // Cancelled
      case CONTRACT_STATUSES.cancelled:
        return {
          className: styles.negative,
          text: 'Cancelled'
        }

      // Abandoned
      case CONTRACT_STATUSES.abandoned:
        return {
          className: styles.negative,
          text: 'Abandoned'
        }

      // Terminated
      case CONTRACT_STATUSES.terminated:
        return {
          className: styles.subdued,
          text: 'Terminated'
        }

      // Effective
      case CONTRACT_STATUSES.effective:
        return {
          className: styles.positive,
          text: 'Effective'
        }

      default:
        return undefined
    }
  }

  // Constants
  const config = getMappedContractStatusConfig()

  return config ? <strong className={config.className}>{config.text}</strong> : undefined
}

export default MappedContractStatus
